import { useFeatureFlag } from '@moda/portal-stanchions';
import { FacadePageType, getRuleContextFromSlug } from '../lib/getRuleContextFromSlug';
import { useAdminMode } from '../components/AdminMode/AdminModeProvider';
import { usePLPPinnedVariantIdVariables } from './usePLPPinnedVariantIdVariables';

export const useRuleVariables = (type: FacadePageType, slug: string) => {
  const { noPinning } = useAdminMode();
  const pinnedVariantIdVariables = usePLPPinnedVariantIdVariables();
  const ruleContext = getRuleContextFromSlug(type, slug);
  const isAbTest = useFeatureFlag(`${ruleContext}_test`, [
    { default: false },
    { if: true, then: true }
  ]);

  if (noPinning) {
    return {
      ruleContexts: [],
      rules: []
    };
  }

  if (pinnedVariantIdVariables) return pinnedVariantIdVariables;

  return {
    ruleContexts: isAbTest ? `${ruleContext}_test` : ruleContext,
    rules: []
  };
};
